module.exports = __webpack_public_path__ + "static/media/vehicle.19582849.jpg";